import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Form, KeyValue } from "../interfaces";

const PREFIX = "SearchRadioButton";

const classes = {
  indentedElement: `${PREFIX}-indentedElement`,
  radioButton: `${PREFIX}-radioButton`,
  formLabel: `${PREFIX}-formLabel`,
};

const StyledRadioGroup = styled(RadioGroup)(() => ({
  [`& .${classes.indentedElement}`]: {
    marginLeft: ".5rem",
  },

  [`& .${classes.radioButton}`]: {
    "& div": {
      border: 0,
      borderRadius: "50%",
    },
  },

  [`& .${classes.formLabel}`]: {
    height: 1,
    margin: -1,
    display: "block",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
  },
}));

export interface Props {
  fieldName: string;
  currentValue: string;
  name: string;
  ariaLabel: string;
  radioButtons: KeyValue[];
  form: Form;
  setForm: (object: any) => void;
}

export function SearchRadioButton({
  fieldName,
  setForm,
  form,
  currentValue,
  name,
  ariaLabel,
  radioButtons,
}: Props) {
  const handleChange = (event: any) => {
    setForm({ ...form, [fieldName]: event.target.value });
  };
  return (
    <StyledRadioGroup
      aria-label={ariaLabel}
      name={name}
      value={currentValue}
      onChange={(e) => handleChange(e)}
    >
      <FormControl component="fieldset">
        <FormLabel component="legend" className={classes.formLabel}>
          {name}
        </FormLabel>
        {radioButtons.map((button: any) => {
          return (
            <FormControlLabel
              className={classes.indentedElement}
              key={button.id}
              value={button.value}
              control={
                <Radio
                  key={button.label}
                  id={button.id}
                  className={classes.radioButton}
                  color="primary"
                />
              }
              label={button.label}
            />
          );
        })}
      </FormControl>
    </StyledRadioGroup>
  );
}
